import { APPLICATION_STATUS_TYPE } from 'app/shared/constants/ApplicationConstants';
import { LEASE_STATUS } from 'app/shared/constants/LeaseConstants';
import { LISTING_SUMMARY_DISPLAY_STATUS } from 'app/shared/constants/ListingSummaryConstants';
import { PAYMENT_STATUS_TYPE } from 'app/shared/constants/PaymentConstants';

const STATUS_TAG_TYPE = {
    // aqua
    AQUA: 'aqua',
    // red
    ERROR: 'error',
    // gray
    GRAY: 'gray',
    // light blue with dark text
    INFO: 'INFO',
    // orange
    ORANGE: 'orange',
    // purple
    PURPLE: 'purple',
    // green
    SUCCESS: 'success',
    // dark gray
    TRANSPARENT: 'transparent',
    // yellow
    WARNING: 'warning',
};

// map for /api/v1/users/properties/summary/listing
const LISTING_SUMMARY = {
    [LISTING_SUMMARY_DISPLAY_STATUS.INACTIVE]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    [LISTING_SUMMARY_DISPLAY_STATUS.PUBLISHING]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    [LISTING_SUMMARY_DISPLAY_STATUS.PUBLISHED]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    [LISTING_SUMMARY_DISPLAY_STATUS.PARTIALLY_PUBLISHED]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    [LISTING_SUMMARY_DISPLAY_STATUS.DECLINED]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.ERROR,
    },
};

// v1 - listing is not connected experience
// v2 - listing is connected experience
// map for /api/{v1/v2}/users/properties/list
const PROPERTY_DETAILS = {
    active: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.PURPLE,
    },
    inactive: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    declined: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
};

// map for /api/v2/users/properties/details/overview
const PROPERTY_DETAILS_OVERVIEW = {
    'off-market': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.TRANSPARENT,
    },
    'listed for rent': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.PURPLE,
    },
    'occupied by tenants': {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.TRANSPARENT,
    },
};

// map for /api/v1/users/properties/summary/leases
const LEASE_SUMMARY = {
    [LEASE_STATUS.ACTIVE]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    [LEASE_STATUS.EXPIRED]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    [LEASE_STATUS.INCOMPLETE_DRAFT]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    [LEASE_STATUS.COMPLETE_DRAFT]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    [LEASE_STATUS.SIGNING_CANCELED]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.PURPLE,
    },
    [LEASE_STATUS.SIGNING_COMPLETE]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    [LEASE_STATUS.SIGNING_IN_PROGRESS]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.AQUA,
    },
    [LEASE_STATUS.SIGNING_OFFLINE]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.AQUA,
    },
    [LEASE_STATUS.AWAITING_YOUR_SIGNATURE]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.ERROR,
    },
};

// map for /api/v1/users/properties/summary/payments
const PAYMENT_SUMMARY = {
    [PAYMENT_STATUS_TYPE.INFO]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    [PAYMENT_STATUS_TYPE.NEUTRAL]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    [PAYMENT_STATUS_TYPE.IN_PROGRESS]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    [PAYMENT_STATUS_TYPE.SUCCESS]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    [PAYMENT_STATUS_TYPE.WARN]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    [PAYMENT_STATUS_TYPE.CAUTION]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.ERROR,
    },
};

// map for /api/v1/users/properties/summary/applications
const INTERESTED_RENTERS = {
    [APPLICATION_STATUS_TYPE.ACCEPTED]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    [APPLICATION_STATUS_TYPE.WITHDRAWN]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
    [APPLICATION_STATUS_TYPE.COMPLETED]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    [APPLICATION_STATUS_TYPE.PENDING]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARN,
    },
    [APPLICATION_STATUS_TYPE.INVITED]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.NEUTRAL,
    },
    received: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.SUCCESS,
    },
    [APPLICATION_STATUS_TYPE.IN_PROGRESS]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.WARNING,
    },
    [APPLICATION_STATUS_TYPE.INVITED_TO_APPLY]: {
        STATUS_TAG_TYPE: STATUS_TAG_TYPE.GRAY,
    },
};

const STATUS_KEY = {
    INTERESTED_RENTERS: 'INTERESTED_RENTERS',
    LEASE_SUMMARY: 'LEASE_SUMMARY',
    LISTING_SUMMARY: 'LISTING_SUMMARY',
    PAYMENT_SUMMARY: 'PAYMENT_SUMMARY',
    PROPERTY_DETAILS: 'PROPERTY_DETAILS',
    PROPERTY_DETAILS_OVERVIEW: 'PROPERTY_DETAILS_OVERVIEW',
};

const LOOKUP = {
    [STATUS_KEY.INTERESTED_RENTERS]: INTERESTED_RENTERS,
    [STATUS_KEY.LEASE_SUMMARY]: LEASE_SUMMARY,
    [STATUS_KEY.LISTING_SUMMARY]: LISTING_SUMMARY,
    [STATUS_KEY.PAYMENT_SUMMARY]: PAYMENT_SUMMARY,
    [STATUS_KEY.PROPERTY_DETAILS]: PROPERTY_DETAILS,
    [STATUS_KEY.PROPERTY_DETAILS_OVERVIEW]: PROPERTY_DETAILS_OVERVIEW,
};

const getTagTypeByKey = (key, status) => {
    try {
        // validation
        if (!key) {
            throw new Error('key is not defined', key);
        }

        if (!status) {
            throw new Error('status is not defined', status);
        }

        // do lookup
        return LOOKUP[key][status.toLowerCase()].STATUS_TAG_TYPE;
    } catch (error) {
        // handle error
        console.error(error);
        // eslint-disable-next-line max-len
        console.error(`A default value of "${STATUS_TAG_TYPE.GRAY}" is being returned. Check status %s against the associated map %s`, status, key);

        // a type is required by the StatusTag component
        return STATUS_TAG_TYPE.GRAY;
    }
};

export {
    STATUS_KEY,
    STATUS_TAG_TYPE,
    getTagTypeByKey,
};
